import { FilePdf } from "@phosphor-icons/react";

export const isImageUrl = (url) => !!url && /\.(png|jpe?g|webp|gif)(\?|$)/i.test(url);

export function FileThumb({ url, size = 32, testid }) {
  if (isImageUrl(url)) {
    return (
      <img
        src={url}
        alt="Anteprima grafica"
        data-testid={testid}
        className="rounded-md object-cover shrink-0 border border-[var(--tf-border)]"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      data-testid={testid}
      className="rounded-md bg-[var(--tf-error)]/10 flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
    >
      <FilePdf size={size * 0.55} weight="fill" className="text-[var(--tf-error)]" />
    </div>
  );
}
